import Name from './routes/Name.svelte'
import {wrap} from 'svelte-spa-router/wrap'
import Wild from './routes/Wild.svelte'
import Play from './routes/Play.svelte'
import Wallet from './routes/Wallet.svelte'
import Details from './components/Details.svelte'
import NotFound from './routes/NotFound.svelte'
import Login from './routes/Login.svelte'
import Privacy from './routes/Privacy.svelte'
import Delete from './routes/Delete.svelte'
import Puzzle from './components/Puzzle.svelte'
import Terms from './routes/Terms.svelte'
import Link from './routes/Link.svelte'
import FlowBox from './components/FlowBox.svelte'
import Game from './routes/Game.svelte'
import {auth} from './firebase.js'
import { getUserData, isUserRegistered } from './userdata'
import FlowBox2 from './components/FlowBox2.svelte'
import Sumsub from './routes/Sumsub.svelte'
import MobilePayment from './routes/MobilePayment.svelte'
// import Wallet from './routes/Wallet.svelte'
import { getAuth } from 'firebase/auth'
// import Legal from './routes/Legal.svelte'
// import Play from './routes/Play.svelte'
// import History from './routes/History.svelte'
//

// Export the route definition object
export default {
    // Exact path

    '/': Login,

    '/Login': Login,
    '/sumsub/:jwt?': Sumsub,
    // Using named parameters, with last being optional
    '/hello/:first/:last?': Name,
    '/FlowBox': FlowBox,
    '/FlowBox2': FlowBox2,
    '/privacy': Privacy,
    '/delete': Delete,
    '/terms': Terms,

    '/link/:code/:tc/:stake': Link,
    '/mobile': MobilePayment,
    '/mobile/:status': MobilePayment,
    '/play/:target_link?/:target_username?/:tc?/:stake?/:code?': wrap({
      component: Play,
      conditions: [(detail) => {
          const reg = isUserRegistered
        return reg
        }

       ]
    }),
    '/play/:payment?': wrap({
      component: Play,
      conditions: [ (detail) => {
          return true
        }

       ]
    }),


    '/details': Details,
  '/puzzle': Puzzle,


    '/Game': wrap({
      component: Game,

      conditions: [ (detail) => {
          const res =  isUserRegistered
          return reg

      } ]
    }),
    '/Wallet': wrap({
      component: Wallet,
      conditions: [ (detail) => {
          const res =  isUserRegistered
          // return res
        return res

      } ]
    }),
    // Wildcard parameter
  //
    // Included twice to match both `/wild` (and nothing after) and `/wild/*` (with anything after)

    // Catch-all, must be last
    '*': NotFound,
}
